// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    overflow: hidden;
}

.app > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.row {
    flex-direction: row !important;
}

.row > * {
    margin: 5px;
}

h1 {
    font-family: "Damion", cursive;
    color: #fff;
    text-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.3);
}

h2 {
    color: #fff;
}

.swipe {
    position: absolute;
    width: 85%;
}

.cardContainer {
    width: 90vw;
    max-width: 260px;
    height: 300px;
}

.card {
    position: relative;
    background-color: #fff;
    width: 80vw;
    max-width: 260px;
    height: 300px;
    box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    background-size: cover;
    background-position: center;
}

.cardContent {
    width: 100%;
    height: 100%;
}

.swipe:last-of-type {
}

.card h3 {
    position: absolute;
    bottom: 0;
    margin: 10px;
    color: #fff;
}

.infoText {
    width: 100%;
    justify-content: center;
    display: flex;
    color: #fff;
    animation-name: popup;
    animation-duration: 800ms;
}

.buttons {
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
}

@media (max-width: 625px) {
    .buttons {
        flex-direction: column;
    }
}

.buttons button {
    flex-shrink: 0;
    padding: 10px;
    border-radius: 5px;
    border: none;
    color: #fff;
    font-size: 18px;
    background-color: #9198e5;
    transition: 200ms;
    margin: 10px;
    font-weight: bolder;
    width: 160px;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
}

.buttons button:hover {
    transform: scale(1.05);
}

@keyframes popup {
    0% {
        transform: scale(1, 1);
    }
    10% {
        transform: scale(1.1, 1.1);
    }
    30% {
        transform: scale(0.9, 0.9);
    }
    50% {
        transform: scale(1, 1);
    }
    57% {
        transform: scale(1, 1);
    }
    64% {
        transform: scale(1, 1);
    }
    100% {
        transform: scale(1, 1);
    }
}
.test {
    color: black;
}

.play-image-advanced {
    margin-right: auto;
    margin-left: auto;
    max-width: 90%;
    width: 90%;
    margin-top: 1vh;
    height: 36vh;
}
.card {
    position: relative;
    /* width: 400px; */
    padding: 20px;
    /* max-width: 85vw; */
    /* height: 50vh; */
    border-radius: 10px;
    height: 55vh;
    width: 90vw;
    /* width: 30vw; */
    background-position: center;
    background-size: contain;
    /* max-width: 90% !important;
    max-height: 65vh !important; */
}

.card h3 {
    color: #fff;
    position: absolute;
    bottom: 0;
    margin: 10px;
}

.tinderCard_container {
    display: flex;
    justify-content: center;
    margin-top: 10vh;
}

.swipe {
    position: absolute;
    /* width: 90%; */
}
.image-item-advance {
    /* cursor: pointer; */
    object-fit: contain;
    border-radius: 15% !important;
    max-height: 55vh !important;
    height: 35vh !important;
    /* min-height: fit-content !important; */
    /* min-width: fit-content !important; */
    /* width: 100% !important; */
    -moz-border-radius: 15% !important;
    -webkit-border-radius: 15% !important;
    overflow: hidden;
    -webkit-user-select: none;
            user-select: none;

    /* width: none !important; */
    /* width: 0; */
    /* width: fit-content !important; */
}
.image-item {
    /* cursor: pointer; */
    object-fit: contain;
    border-radius: 15% !important;
    max-height: 55vh !important;
    height: 43vh !important;
    /* min-height: fit-content !important; */
    /* min-width: fit-content !important; */
    /* width: 100% !important; */
    -moz-border-radius: 15% !important;
    -webkit-border-radius: 15% !important;
    overflow: hidden;
    -webkit-user-select: none;
            user-select: none;

    /* width: none !important; */
    /* width: 0; */
    /* width: fit-content !important; */
}
.yomi-image {
    font-size: 1.5rem;
    font-weight: 300;
    white-space: pre-wrap;
    margin: auto;
    width: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Advanced.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,gDAAgD;AACpD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,eAAe;IACf,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,wBAAwB;IACxB;kCAC8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,wCAAwC;IACxC,uCAAuC;IACvC,4BAA4B;IAC5B,kCAAkC;IAClC,qCAAqC;IACrC,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;;IAEjB,4BAA4B;IAC5B,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,wCAAwC;IACxC,uCAAuC;IACvC,4BAA4B;IAC5B,kCAAkC;IAClC,qCAAqC;IACrC,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;;IAEjB,4BAA4B;IAC5B,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,UAAU;AACd","sourcesContent":[".app {\r\n    overflow: hidden;\r\n}\r\n\r\n.app > div {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.row {\r\n    flex-direction: row !important;\r\n}\r\n\r\n.row > * {\r\n    margin: 5px;\r\n}\r\n\r\nh1 {\r\n    font-family: \"Damion\", cursive;\r\n    color: #fff;\r\n    text-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\nh2 {\r\n    color: #fff;\r\n}\r\n\r\n.swipe {\r\n    position: absolute;\r\n    width: 85%;\r\n}\r\n\r\n.cardContainer {\r\n    width: 90vw;\r\n    max-width: 260px;\r\n    height: 300px;\r\n}\r\n\r\n.card {\r\n    position: relative;\r\n    background-color: #fff;\r\n    width: 80vw;\r\n    max-width: 260px;\r\n    height: 300px;\r\n    box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.3);\r\n    border-radius: 20px;\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n\r\n.cardContent {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.swipe:last-of-type {\r\n}\r\n\r\n.card h3 {\r\n    position: absolute;\r\n    bottom: 0;\r\n    margin: 10px;\r\n    color: #fff;\r\n}\r\n\r\n.infoText {\r\n    width: 100%;\r\n    justify-content: center;\r\n    display: flex;\r\n    color: #fff;\r\n    animation-name: popup;\r\n    animation-duration: 800ms;\r\n}\r\n\r\n.buttons {\r\n    margin: 20px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n@media (max-width: 625px) {\r\n    .buttons {\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.buttons button {\r\n    flex-shrink: 0;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    color: #fff;\r\n    font-size: 18px;\r\n    background-color: #9198e5;\r\n    transition: 200ms;\r\n    margin: 10px;\r\n    font-weight: bolder;\r\n    width: 160px;\r\n    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.buttons button:hover {\r\n    transform: scale(1.05);\r\n}\r\n\r\n@keyframes popup {\r\n    0% {\r\n        transform: scale(1, 1);\r\n    }\r\n    10% {\r\n        transform: scale(1.1, 1.1);\r\n    }\r\n    30% {\r\n        transform: scale(0.9, 0.9);\r\n    }\r\n    50% {\r\n        transform: scale(1, 1);\r\n    }\r\n    57% {\r\n        transform: scale(1, 1);\r\n    }\r\n    64% {\r\n        transform: scale(1, 1);\r\n    }\r\n    100% {\r\n        transform: scale(1, 1);\r\n    }\r\n}\r\n.test {\r\n    color: black;\r\n}\r\n\r\n.play-image-advanced {\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    max-width: 90%;\r\n    width: 90%;\r\n    margin-top: 1vh;\r\n    height: 36vh;\r\n}\r\n.card {\r\n    position: relative;\r\n    /* width: 400px; */\r\n    padding: 20px;\r\n    /* max-width: 85vw; */\r\n    /* height: 50vh; */\r\n    border-radius: 10px;\r\n    height: 55vh;\r\n    width: 90vw;\r\n    /* width: 30vw; */\r\n    background-position: center;\r\n    background-size: contain;\r\n    /* max-width: 90% !important;\r\n    max-height: 65vh !important; */\r\n}\r\n\r\n.card h3 {\r\n    color: #fff;\r\n    position: absolute;\r\n    bottom: 0;\r\n    margin: 10px;\r\n}\r\n\r\n.tinderCard_container {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 10vh;\r\n}\r\n\r\n.swipe {\r\n    position: absolute;\r\n    /* width: 90%; */\r\n}\r\n.image-item-advance {\r\n    /* cursor: pointer; */\r\n    object-fit: contain;\r\n    border-radius: 15% !important;\r\n    max-height: 55vh !important;\r\n    height: 35vh !important;\r\n    /* min-height: fit-content !important; */\r\n    /* min-width: fit-content !important; */\r\n    /* width: 100% !important; */\r\n    -moz-border-radius: 15% !important;\r\n    -webkit-border-radius: 15% !important;\r\n    overflow: hidden;\r\n    user-select: none;\r\n\r\n    /* width: none !important; */\r\n    /* width: 0; */\r\n    /* width: fit-content !important; */\r\n}\r\n.image-item {\r\n    /* cursor: pointer; */\r\n    object-fit: contain;\r\n    border-radius: 15% !important;\r\n    max-height: 55vh !important;\r\n    height: 43vh !important;\r\n    /* min-height: fit-content !important; */\r\n    /* min-width: fit-content !important; */\r\n    /* width: 100% !important; */\r\n    -moz-border-radius: 15% !important;\r\n    -webkit-border-radius: 15% !important;\r\n    overflow: hidden;\r\n    user-select: none;\r\n\r\n    /* width: none !important; */\r\n    /* width: 0; */\r\n    /* width: fit-content !important; */\r\n}\r\n.yomi-image {\r\n    font-size: 1.5rem;\r\n    font-weight: 300;\r\n    white-space: pre-wrap;\r\n    margin: auto;\r\n    width: 90%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
